export default __webpack_public_path__ + "static/media/11-maio.1ad623df.mp4";